import { render, staticRenderFns } from "./CadastroProdutoPeriodoSazonal.vue?vue&type=template&id=90be6c82"
import script from "./CadastroProdutoPeriodoSazonal.vue?vue&type=script&lang=js"
export * from "./CadastroProdutoPeriodoSazonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports